import { useMemo } from 'react'
import { Provider as ReduxProvider } from 'react-redux'
import { ScreenClassProvider } from '@vp/swan'
import { useLogger, useUserContext } from '@vp/ubik-context'

import { configureStore } from 'client/store/configureStore'
import { QueryProviderWrapper } from '~/client/components/FragmentRoot/QueryProviderWrapper'
import { IntlContext } from 'client/contexts/IntlContext'
import { AnalyticsContext } from 'client/contexts/gallery/AnalyticsContext'
import { Analytics } from 'client/utils/gallery/analytics/analytics'
import { FragmentRootProps } from 'client/components/FragmentRoot/interface'
import { IS_BROWSER } from 'client/constants'
import { IdentityProviderWrapper } from 'client/contexts/identity/provider'
import { PricingContextProvider } from 'client/contexts/pricing/provider'
import { Gallery as GalleryRoot } from 'client/components/Gallery/index'

export const FragmentRoot = ({ initialReduxState, initialQueryState, translations }: FragmentRootProps) => {
  const logger = useLogger()
  const userContext = useUserContext()

  if (IS_BROWSER) {
    logger.info('Rendering fragment client: ', initialReduxState.config, userContext)
  }

  const localizations = useMemo(() => ({ messages: translations }), [translations])
  const analytics = useMemo(() => new Analytics(logger), [logger])

  const store = configureStore(initialReduxState, analytics)

  return (
    <ReduxProvider store={store}>
      <IntlContext.Provider value={localizations}>
        <AnalyticsContext.Provider value={analytics}>
          <QueryProviderWrapper state={initialQueryState}>
            <ScreenClassProvider>
              <IdentityProviderWrapper>
                <PricingContextProvider>
                  <GalleryRoot />
                </PricingContextProvider>
              </IdentityProviderWrapper>
            </ScreenClassProvider>
          </QueryProviderWrapper>
        </AnalyticsContext.Provider>
      </IntlContext.Provider>
    </ReduxProvider>
  )
}

FragmentRoot.displayName = 'FragmentRoot'
